var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { class: _vm.radioClasss },
    [
      !_vm.isButtonGroup
        ? _c("span", { staticClass: "mku-radio__inner" })
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        staticClass: "mku-radio__input",
        attrs: { type: "radio", disabled: _vm.disabled },
        domProps: { value: _vm.label, checked: _vm.checked },
        on: { change: _vm.handleRadioChange }
      }),
      _vm._v(" "),
      _vm._t("default", [_vm._v(_vm._s(_vm.label))])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }